<template>
  <div class="home w">
    <!-- 轮播图 -->
    <HomeBanner/>

    <HomeCount/>

    <HomePatent/>

    <!-- &lt;!&ndash; 新鲜好物 &ndash;&gt;
     <HomeNew />
     &lt;!&ndash; 人气推荐 &ndash;&gt;
     <HomeHot />
     &lt;!&ndash; 产品区块 &ndash;&gt;
     <HomeProduct />-->

  </div>
</template>

<script>
import HomeBanner from './HomeBanner.vue'
import HomeCount from './HomeCount.vue'
import HomePatent from './HomePatent'

export default {
  components: {
    HomeBanner,
    HomeCount,
    HomePatent

  }
};
</script>

<style lang="less" scoped>
</style>